import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';

@Component({
    standalone: false,
    selector: 'bp-adresse',
    templateUrl: './adresse.component.html',
    styleUrls: ['./hl-area.component.css'],
    
})
export class AdresseComponent extends HlAreaComponent {
  forstamtFilter(fa: string) {
    return (value: string, row?: any) => {
      if (!row || !row['FORSTAMT']) return false;
      return row['FORSTAMT'] === fa;
    };
  }
}
